import React from 'react';
import OrderItem from './OrderItem';
import { Typography, Collapse } from '@mui/material';
export default function OrderReview(props) {
  const { itemCount, channelCount } = props;
  let items = 0;
  itemCount.forEach((element) => {
    if (element.id.trim().length > 0) items++;
  });
  let cost =
    parseInt(channelCount) === 1000
      ? 600
      : (parseInt(channelCount) - 5) * 3 + 50;
  return (
    <React.Fragment>
      <Typography variant='h5' mb={3}>
        Order Review
      </Typography>
      <Typography sx={{ fontSize: '14px', fontWeight: '400' }}>
        {items} items
      </Typography>
      <Collapse in={true} timeout='auto' unmountOnExit>
        <OrderItem
          channels={channelCount === 1000 ? 'unlimited' : channelCount}
          cost={cost}
        />
      </Collapse>
    </React.Fragment>
  );
}
